import { FC } from 'react';
import classnames from 'classnames';
import { CircleHelp, LucideProps } from 'lucide-react';

import ICONS from './map';

type IconProperties = Omit<LucideProps, 'ref' | 'name'> & {
  name?: string;
};

const Icon: FC<IconProperties> = ({
  name,
  size = '1em',
  className,
  ...rest
}) => {
  const Glyph = (name && ICONS[name]) || CircleHelp;

  return (
    <Glyph
      size={size}
      className={classnames('ui__svg-icon', name, className)}
      aria-hidden={rest['aria-label'] ? undefined : true}
      {...rest}
    />
  );
};

export default Icon;
